<template>
  <div>
    <surveys-table
      surveyName="PASI"
      surveyCode="PASI"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_PASI,
        viewDetail: permissions.SEE_DETAIL_SURVEY_PASI,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";
export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
